<template>
  <div class="recording-card" v-if="recordingInterview.recording_content.length > 0">
    <!-- コピー用 -->
    <input
      type="hidden"
      style="opacity: 0 !important"
      :id="'copy-code-' + recordingInterview.id"
      :value="url"
    />
    <p class="-title">
      {{ recordingInterview.name }}
    </p>
    <p class="-desc">
      {{ recordingInterview.recording_content[index].name }}
    </p>
    <div class="video-wrapper">
      <template v-for="(content, idx) in recordingInterview.recording_content">
        <img
          :key="idx"
          class="video-back"
          v-if="index === idx && !isError"
          @error="error"
          :src="content.question_recording_pic"
        />
      </template>
      <div fallback style="height: 140px; padding-top: 40px" v-if="isError">
        <p>本画像の有効期限が過ぎました。</p>
      </div>
      <button class="button prev-button" @click="changeIndex(-1)" :disabled="isMinIndex">
        <span class="mdi mdi-chevron-left"></span>
      </button>
      <button class="button next-button" @click="changeIndex(1)" :disabled="isMaxIndex">
        <span class="mdi mdi-chevron-right"></span>
      </button>
    </div>
    <button class="button -menu" @click="changeModalEditRecord(true, recordingInterview)">
      <span class="mdi mdi-playlist-edit -right-8px"></span>
      詳　細
    </button>
    <button class="button -menu" @click="changeModalAnswerRecord(true, recordingInterview)">
      <div class="unread" v-if="unreadCnt > 0">
        {{ unreadCnt }}
      </div>
      <span class="mdi mdi-account-location -right-8px"></span>
      回　答
    </button>
    <button class="button -menu" @click="copyLink()">
      <span class="mdi mdi-link-variant -right-8px"></span>
      リンク
    </button>
    <button class="button -menu" @click="changeModalDeleteRecord(true, recordingInterview)">
      <span class="mdi mdi-close -right-8px"></span>
      削　除
    </button>
  </div>
  <div v-else class="recording-card loading-container">
    <div class="loading-wrapper"><i class="mdi mdi-loading mdi-spin mdi-48px"></i></div>
  </div>
</template>

<script>
export default {
  props: {
    recordingInterview: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    changeModalAnswerRecord: {
      type: Function,
    },
  },
  computed: {
    isMaxIndex() {
      return this.index === (this.recordingInterview && this.recordingInterview.recording_content ? this.recordingInterview.recording_content.length : 0) - 1
    },
    isMinIndex() {
      return this.index === 0
    },
    unreadCnt() {
      let cnt = 0
      let all = 0
      let read = 0
      
      // recording_contentが存在するか確認
      if (!this.recordingInterview || !this.recordingInterview.recording_content) {
        return 0
      }

      for (const content of this.recordingInterview.recording_content) {
        // recording_answerが存在するか確認
        if (!content || !content.recording_answer) {
          continue
        }

        for (const answer of content.recording_answer) {
          all += 1
          // read_userが存在し、includesメソッドが使えるか確認
          if (answer && answer.read_user && typeof answer.read_user.includes === 'function' 
              && answer.read_user.includes(this.user.userHash)) {
            read += 1
          }
        }
      }
      
      cnt = all - read
      return cnt > 99 ? 99 : cnt
    },
  },
  data() {
    return {
      index: 0,
      url: '',
      isError: false,
    }
  },
  methods: {
    changeIndex(delta) {
      this.isError = false
      const res = delta + this.index
      const max = this.recordingInterview.recording_content.length - 1
      if (res < 0) {
        this.index = max
      } else if (res > max) {
        this.index = 0
      } else {
        this.index = res
      }
      this.$forceUpdate()
    },
    copyLink() {
      this.url =
        process.env.OWN_ENDPOINT +
        '/recruits/recording_interview/' +
        this.user.companyID +
        '/' +
        this.recordingInterview.id
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy-code-' + this.recordingInterview.id)
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'URLをコピーしました',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true,
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    changeModalEditRecord(flg, data) {
      this.$emit('change-modal-edit-record', flg, data)
    },
    changeModalDeleteRecord(flg, data) {
      this.$emit('change-modal-delete-record', flg, data)
    },
    error() {
      this.isError = true
    },
  },
}
</script>

<style lang="scss" scoped>
.recording-card {
  margin: 12px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  padding: 16px;
  min-width: 280px;
  min-height: 368px;
  width: calc(25% - 24px);
  height: calc(33% - 24px);
  .-title {
    font-size: 16px;
    color: #a22;
    font-weight: 600;
    text-align: left;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 4px;
  }
  .-desc {
    font-size: 12px;
    text-align: left;
    color: #666;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 4px;
  }
  .video-wrapper {
    position: relative;
    padding: 8px 32px;
    .video-back {
      border-radius: 8px;
      max-height: 168px;
    }
    .next-button {
      position: absolute;
      width: 32px;
      height: 32px;
      background: #22222299;
      color: white;
      border-radius: 50%;
      border: solid 2px #ccc;
      top: 50%;
      right: -24px;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      padding: 0;
      font-size: 24px;
    }
    .prev-button {
      position: absolute;
      width: 32px;
      height: 32px;
      background: #22222299;
      color: white;
      border-radius: 50%;
      border: solid 2px #ccc;
      top: 50%;
      left: 8px;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      padding: 0;
      font-size: 24px;
    }
  }
  .-menu {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    border: none;
    width: calc(50% - 8px);
    margin: 4px 2px;
    position: relative;
    .unread {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 28px;
      height: 28px;
      background: #c82e42;
      font-size: 14px;
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .-menu:hover {
    border: solid thin #a22;
    color: #a22;
  }
}
.recording-card:hover {
  border: solid thin #a22;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoView/organisms/RecordingInterviewCard.vue